import { render } from "./UserQueryMaster.vue?vue&type=template&id=26a0f8b8&scoped=true"
import script from "./UserQueryMaster.vue?vue&type=script&lang=js"
export * from "./UserQueryMaster.vue?vue&type=script&lang=js"

import "./UserQueryMaster.vue?vue&type=style&index=0&id=26a0f8b8&scoped=true&lang=css"
import "./UserQueryMaster.vue?vue&type=style&index=1&id=26a0f8b8&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a0f8b8"]])

export default __exports__